<template>
  <div class="drawer">
    <el-drawer
      size="740px"
      title="选择宠物寄养笼子位置"
      :visible.sync="drawerStatus"
      @close="handleClose"
      :modal-append-to-body="false"
    >
      <div class="contentCage">
        <div class="con">
          <div class="cageName">笼子分区</div>
          <div style="height: 10px"></div>
          <div class="contentItem">
            <el-radio-group v-model="areaId" @input="handleChangEarea">
              <el-radio label="1">展示区</el-radio>
              <el-radio label="3">寄养区</el-radio>
            </el-radio-group>
          </div>
          <div style="height: 20px"></div>
        </div>
        <div class="con"  v-for="(itemb, index) in cageListArr" :key="itemb.id" v-show="itemb.length"> 
          <div class="cageName" v-show="itemb.length">{{ cagePositionNameList[index] }}</div>
          <div class="contentItem">
            <div
              class="cageItem"
              :class="changeClass(item)"
              v-for="item in itemb"
              :key="item.id"
              @click="changeCageId(item)"
            >
              <div>{{ item.cageName }}</div>
              <div
                v-show="item.pets.length"
                v-for="itemA in item.pets.slice(0, 1)"
                :key="itemA.id"
              >
                {{ itemA.petType == "1" ? "猫" : "狗" }}
                {{ item.pets.length }}只
              </div>
              <div v-show="!item.pets.length">{{ item.status.title }}</div>
            </div>
          </div>
        </div>
       
      </div>

      <div class="btnBox">
        <div class="btnItem" @click="handleClose">取消</div>
        <div class="btnItem submit" @click="sumbit()">确定</div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { petReceive } from "@/api/purchaseApi.js";
export default {
  props: {
    petId: {
      type: String,
      default: "",
    },
    qwe: {
      default: "",
    },
    type:{
      default: "",
    },
    apply_type:{
      default: "",
    }      
  },
  data() {
    return {
      shopId:this.receiveShopId||this.$store.state.shopId,
      cageId: "",
      drawerStatus: false,
      areaId: "3",
      status: "",
      positionId: "",
      cageName:'',
      positionName:'',
      areaList: this.$store.state.areaList,
      cageList: [],
      cageListArr: [],
       // 位置列表
       cagePositionList: [],
      cagePositionNameList: [],
      petType:''
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.drawerStatus = true;
      this.getCageTree();
      this.getCageList();
    });
    console.log(this.apply_type,"apply_type123");
    // console.log("petCage", this.type);
  },
  computed:{
    changeClass() {
      return (item) => {
        if (item.status.value == 2 || item.status.value == 1) {
          return "lockClass";
        }
        if (item.cageId == this.cageId) {
          return "pitchClass";
        }
        return "";
      }
    },
  },
  methods: {
      
    // 确定
    sumbit() {
     
      if (this.$public.isNull(this.cageId)) {
        this.$message({
          type: "error",
          message: "请选择房间",
        });
        return;
      }

      if (this.type == "change") {
          let params = {
          petId: this.petId,
          cageInfo:{
          
          },
        };
        params.cageInfo.cageId=this.cageId;
        params.cageInfo.positionId=this.positionId
        params.cageInfo.cageName=this.cageName
        params.cageInfo.positionName=this.positionName
        let loading = this.$loading();
        this.$http
          .post(process.env.VUE_APP_apiHost + "api/FosterCare/changeCage", params)
          .then((res) => {
            loading.close();
            this.$emit("submit",
            {type:'submit',positionId:this.positionId,positionName:this.positionName,cageName:this.cageName,cageId:this.cageId}
            );
        });
      
      } else {
          console.log(this.cageName,"cageNamecageName");
          this.$emit("submit",
            {type:'submit',positionId:this.positionId,positionName:this.positionName,cageName:this.cageName,cageId:this.cageId}
            );
         
      }
    },
    // 选择笼子
    changeCageId(item) {
      console.log(item,"选择笼子item");
      let flag =false
      if(item.pets!==[]){
        item.pets.map((itema)=>{
          this.petType=Number(itema.petType)
          
          if(this.apply_type!==this.petType){
            this.$message({
          message: "猫狗不能同笼",
          type: "error",
        });
        this.cageId = '';
        flag =true
          }
          
        })
       
      }
      if(flag)return
      if (item.status.value == 2 || item.status.value == 1) {
        this.$message({
          message: "请选择其他房间",
          type: "error",
        });
        return;
      }else  if (this.cageId == item.cageId) {
        this.cageId = "";
      } else {
        this.positionId=item.positionId;
        this.positionName=item.positionName;
        this.cageName=item.cageName;
        this.cageId=item.cageId;

      }
    },
   
  
     // 获取笼子位置树
     getCageTree() {
      this.$http
        .get(process.env.VUE_APP_Url_8000 + "/api/cage/area/tree", {
          shopId: this.shopId,
        })
        .then((res) => {
          if (res.code == 0) {
            this.cageData = res.data;
            let arr = [];
            let arrName = [];
            this.cageData.forEach((item) => {
              if (item.children.length) {
                item.children.forEach((itemB) => {
                  arr.push(itemB.id);
                  arrName.push(item.label + "--" + itemB.label);
                });
              }
            });
            this.cagePositionList = arr;
            this.cagePositionNameList = arrName;
          }
        });
    },
    // 获取笼子列表
    getCageList() {
      let params = {
        shopId: this.shopId,
        cageAreaId: this.areaId,
        positionId: this.positionId,
        status: this.status,
      };
      // console.log(params);
      let loading = this.$loading();
      this.$http
        .post(
          process.env.VUE_APP_Url_8000 + "/api/shop/cage/current/status/list",
          params
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            // console.log(res.data, "狗笼子列表");
            this.cageList = res.data;
            let allArr = [];
            this.cagePositionList.forEach((itemA) => {
              let arr = this.cageList.filter(
                (itemB) => itemA == itemB.positionId
              );
              allArr.push(arr);
            });
            this.cageListArr = allArr;
          }
        });
    },

    handleChangEarea() {
      this.getCageList();
    },
    // 关闭弹框
    handleClose(){
      this.$emit('submit',{type:'close'})
    },
    
    
  },
};
</script>

<style scoped lang="scss">
.drawer {
  ::v-deep .el-drawer__body {
    overflow-y: auto;
    padding-bottom: 30px;
  }
  .contentCage {
    margin: 0px 20px;
    .con {
      background: #fbfbfb;
      border-radius: 16px;
      padding: 10px 0px;
      margin-bottom: 20px;
      .contentItem {
        margin: 10px 0px;
        margin-left: 10px;
        display: flex;
        flex-wrap: wrap;
        .cageItem {
          margin-bottom: 5px;
          margin-right: 5px;
          text-align: center;
          border-radius: 8px;
          background: #f5f5f6;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          width: 126px;
          height: 80px;
          cursor: pointer;
        }
        .lockClass {
          color: #b0b0bf;
        }
        .pitchClass {
          color: $mainColor;
          border: 1px solid $mainColor;
        }
      }
    }

    .cageName {
      font-weight: 600;
      margin-top: 20px;
      border-left: 3px solid #0272da;
      padding-left: 20px;
      margin-bottom: 20px;
    }
  }
  .btnBox {
    width: 100%;
    font-size: 14px;
    color: #fff;
    line-height: 40px;
    display: flex;
    position: absolute;
    bottom: 0;
    z-index: 10;
    .btnItem {
      text-align: center;
      width: 100%;
      background-color: #d6d6d6;
      cursor: pointer;
      &.submit {
        background-color: $mainColor;
      }
    }
  }
}
</style>